import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const faqItem = css({
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'rgba(209, 209, 214, 0.50)',
  paddingTop: '2x',
  paddingBottom: '2x',
  '&:first-of-type': {
    borderTopWidth: 0,
    paddingTop: 0,
  },
  '&[open] > summary': {
    marginBottom: '1x',
  },
});

export const faqSummary = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '2x',
  cursor: 'pointer',
  listStyle: 'none',
  padding: 0,
  fontSize: 'md',
  lineHeight: 'md',
  color: 'hpxBlue500',
  fontWeight: 'bold',
  '&::-webkit-details-marker': {
    display: 'none',
  },
  '&::marker': {
    content: '""',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderRadius: '4px',
  },
});

export const caret = css({
  flexShrink: 0,
  transitionProperty: 'transform',
  transitionDuration: '200ms',
  transitionTimingFunction: 'ease',
  'details[open] &': {
    transform: 'rotate(180deg)',
  },
  '@media (prefers-reduced-motion: reduce)': {
    transitionDuration: '0ms',
  },
});

export const answerBody = css({
  fontSize: 'md',
  lineHeight: 'md',
  color: 'hpxBlue500',
  marginTop: '1x',
});

export const answerList = css({
  fontSize: 'md',
  lineHeight: 'md',
  color: 'hpxBlue500',
  marginTop: '1x',
  paddingLeft: '3x',
  display: 'flex',
  flexDirection: 'column',
  gap: 'xs',
});

export const answerListHeader = css({
  fontSize: 'md',
  lineHeight: 'md',
  color: 'hpxBlue500',
  marginTop: '1x',
});
